import Scrollbar from "smooth-scrollbar";

function setMain() {
  let setMainInt = setInterval(() => {
    let pageContent = document.querySelector("#pageContent");

    if (pageContent) {
      if (Scrollbar.has(pageContent)) clearInterval(setMainInt);
      else Scrollbar.init(pageContent, { alwaysShowTracks: true });
    }
  }, 100);
}

function setLeftSide() {
  let setLsInt = setInterval(() => {
    let leftSide = document.querySelector("#leftSide");

    if (leftSide) {
      if (Scrollbar.has(leftSide)) clearInterval(setLsInt);
      else
        Scrollbar.init(leftSide, {
          alwaysShowTracks: true,
          continuousScrolling: true,
        });
    }
  }, 100);
}

function setContentBox() {
  let setCbInt = setInterval(() => {
    let contentBoxBody = document.querySelector("#contentBoxBody");

    if (contentBoxBody) {
      if (Scrollbar.has(contentBoxBody)) clearInterval(setCbInt);
      else
        Scrollbar.init(contentBoxBody, {
          alwaysShowTracks: true,
          continuousScrolling: true,
          overscrollEffect: true,
        });
    }
  }, 100);
}

function removeContentBox() {
  let removeCbInt = setInterval(() => {
    let contentBoxBody = document.querySelector("#contentBoxBody");

    if (contentBoxBody) {
      if (Scrollbar.has(contentBoxBody)) {
        Scrollbar.destroy(contentBoxBody);
      }
      clearInterval(removeCbInt);
    }
  }, 100);
}

function removeMain() {
  let removeMainInt = setInterval(() => {
    let pageContent = document.querySelector("#pageContent");

    if (pageContent) {
      if (Scrollbar.has(pageContent)) {
        Scrollbar.destroy(pageContent);
      }
      clearInterval(removeMainInt);
    }
  }, 100);
}

function setDomainList() {
  let setDlInt = setInterval(() => {
    let domainsList = document.querySelector(".MuiCollapse-entered");

    if (domainsList) {
      if (Scrollbar.has(domainsList)) clearInterval(setDlInt);
      else
        Scrollbar.init(domainsList, {
          alwaysShowTracks: true,
          continuousScrolling: true,
        });
    }
  }, 1);
}

function contentBoxToTop() {
  let contentBoxBody = document.querySelector("#contentBoxBody");
  let cbAnchor = document.querySelector("#cbAnchor");
  if (cbAnchor) cbAnchor.scrollIntoView({ behavior: "smooth" });

  let toTopInterval = setInterval(() => {
    contentBoxBody = document.querySelector("#contentBoxBody");
    let scrollInstance = Scrollbar.get(contentBoxBody);

    if (contentBoxBody && scrollInstance) {
      scrollInstance.scrollTo(0, 0, 300);
      clearInterval(toTopInterval);
    }
  }, 100);
}

function scrollToTop() {
  if (window.screen.availWidth > 768) {
    let pageContent = document.querySelector("#pageContent");
    let scrollInstance = Scrollbar.get(pageContent);
    if (scrollInstance) scrollInstance.scrollTo(0, 0, 1000);
  } else
    document
      .getElementsByTagName("html")[0]
      .scrollIntoView({ behavior: "smooth" });
}

function leftSideToTop() {
  if (window.screen.availWidth > 768) {
    let leftSide = document.querySelector("#leftSide");
    let scrollInstance = Scrollbar.get(leftSide);
    if (scrollInstance) scrollInstance.scrollTo(0, 0, 1000);
  } else
    document
      .getElementsByTagName("html")[0]
      .scrollIntoView({ behavior: "smooth" });
}

export const Scroll = {
  setMain,
  setLeftSide,
  setContentBox,
  removeContentBox,
  removeMain,
  setDomainList,
  contentBoxToTop,
  scrollToTop,
  leftSideToTop,
};
export default Scroll;
